import angular from "angular";
import controller from "./student-orders.controller";
import template from "./student-orders.html";
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.students.view.orders", {
    url: "/orders",
    controller: controller,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
        USER_ROLES.staff,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.students.view.orders", [])
  .config(config)
  .controller("AdminStudentViewOrdersController", controller);
